import {
    bazaarMyBazaarUrl,
    bazaarMyReviewsFromBuyersUrl,
    bazaarMyReviewsFromSellersUrl,
    bazaarMyTransactionsUrl,
    bazaarMyWidgetUrl, bazaarProductDetailUrl,
    bazaarSellerBazaarUrl,
    bazaarSellerReviewsFromBuyersUrl,
    bazaarSellerReviewsFromSellersUrl,
    bazaarSellerSearchUrl,
} from 'mk2/apps/bazaar/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'bazaar',
    exact: true,
    path: bazaarSellerSearchUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/SellerSearch/SellerSearchPage' /* webpackChunkName: "bazaar.SellerSearch" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/SellerSearch/SellerSearchPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarSellerReviewsFromBuyersUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/SellerReviews/SellerReviewsPage' /* webpackChunkName: "bazaar.SellerReviews" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/SellerReviews/SellerReviewsPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarSellerReviewsFromSellersUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/SellerReviews/SellerReviewsPage' /* webpackChunkName: "bazaar.SellerReviews" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/SellerReviews/SellerReviewsPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarMyReviewsFromBuyersUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/MyReviews/MyReviewsPage' /* webpackChunkName: "bazaar.MyReviews" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/MyReviews/MyReviewsPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarMyReviewsFromSellersUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/MyReviews/MyReviewsPage' /* webpackChunkName: "bazaar.MyReviews" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/MyReviews/MyReviewsPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarMyWidgetUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/MyWidget/MyWidgetPage' /* webpackChunkName: "bazaar.MyWidget" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/MyWidget/MyWidgetPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarMyTransactionsUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/MyTransactions/MyTransactionsPage' /* webpackChunkName: "bazaar.MyTransactions" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/MyTransactions/MyTransactionsPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarMyBazaarUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/MyBazaar/MyBazaarPage' /* webpackChunkName: "bazaar.MyBazaar" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/MyBazaar/MyBazaarPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarSellerBazaarUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/HerBazaar/HerBazaarPage' /* webpackChunkName: "bazaar.HerBazaar" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/HerBazaar/HerBazaarPage' ],
}, {
    app: 'bazaar',
    exact: true,
    path: bazaarProductDetailUrl,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/ProductDetail/ProductDetailPage' /* webpackChunkName: "bazaar.ProductDetail" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/ProductDetail/ProductDetailPage' ],
}];
